import { render, staticRenderFns } from "./report-items.vue?vue&type=template&id=f48dd2a8&"
import script from "./report-items.vue?vue&type=script&lang=js&"
export * from "./report-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports